import React, { Component } from "react";
import styles from "./Effect.module.scss";
import { generateConfetti } from "./Confetti.effect";
import { generateSnow } from "./Snow.effect";
import { generateStars } from "./Stars.effect";
import { generateTwinkle } from "./Twinkle.effect";

class Effect extends Component {

	componentDidMount() {
		//canvas init
		this.canvas = document.getElementById("effectcontainer");
		this.ctx = this.canvas.getContext("2d");

		//canvas dimensions
		this.width = window.innerWidth;
		this.height = window.innerHeight;
		this.canvas.width = this.width;
		this.canvas.height = this.height;
		this.angle = 0;
		this.mp = 0;
		this.particles = [];

		const anim = () => {
			this.updateAnimation();
			requestAnimationFrame(anim);
		};
		requestAnimationFrame(anim);

		this.componentDidUpdate();
	}

	componentDidUpdate() {
		if (this.props.active) {
			const generator = {
				snow: generateSnow,
				confetti: generateConfetti,
				stars: generateStars,
				twinkle: generateTwinkle,
			}[this.props.active];

			if (generator) {
				generator(this.width, this.height).then((result) => {
					this.mp = result.mp;
					this.particles = result.particles;
					this.draw = result.draw;
					this.updateParticles = result.update;
				});
			}
		}
	}

	updateAnimation() {
		if (this.updateParticles) {
			this.updateParticles();

			//Lets draw the flakes
			this.ctx.clearRect(0, 0, this.width, this.height);

			for (let i = 0; i < this.mp; i++) {
				let p = this.particles[i];
				this.draw(p, this.ctx);
			}
		}
	}

	render() {
		return (
			<div className={styles.host}>
				<canvas id="effectcontainer"></canvas>
			</div>
		);
	}
}

export default Effect;
